import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import $ from 'jquery';

function PrivateRoute({ location, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        $.cookie('authorization') && $.cookie('m_u') && $.cookie('m_c') ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/account/signIn',
              state: { from: location.pathname.slice(1) },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
